import styled from "styled-components";

export const Button = styled.button`
  color: #fff;
  font-size: 1.8rem;
  border-radius: .5rem;
  border: none;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  background-color: ${({theme}) => theme.colors.primaryLight};
  cursor: pointer;
  padding: 15px 40px;

  &:hover {
    opacity: 0.9;
    transform: scale(0.98);
    background-color: #327EC7;
  }
`;
